export function formatDatetime(datetime: string): string {
  const date = new Date(datetime)
  return new Intl.DateTimeFormat("nb-NO", {
    dateStyle: "short",
    timeStyle: "long",
  }).format(date)
}
